/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import AnimatedSvgContainer from './animated-svg-container';
var borderContainerStyles = null;
var borderContentStyles = null;

/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */
var AIGlowingBorder = function AIGlowingBorder(_ref) {
  var children = _ref.children,
    palette = _ref.palette,
    _ref$isMoving = _ref.isMoving,
    isMoving = _ref$isMoving === void 0 ? true : _ref$isMoving,
    isGlowing = _ref.isGlowing,
    testId = _ref.testId,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testId,
    className: ax(["_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1bsb1ns9"])
  }, /*#__PURE__*/React.createElement(AnimatedSvgContainer, {
    palette: palette,
    isMoving: isMoving,
    className: className
  }), isGlowing &&
  /*#__PURE__*/
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
  React.createElement(AnimatedSvgContainer, {
    palette: palette,
    isMoving: isMoving,
    isGlowing: true,
    className: className
  }), /*#__PURE__*/React.createElement("div", {
    className: ax(["_2rkoftgi _16jlkb7n _1pbykb7n"])
  }, children, " "));
};
export default AIGlowingBorder;